import { ModalConfiguration } from '@40seas/payments-shared';
import { createContext } from 'react';

//@ts-ignore - Fix TS FS-3199
export const PaymentConfigurationContext = createContext<ModalConfiguration>({ theme: {}, options: {} });
